// extracted by mini-css-extract-plugin
export default {"control":"Product_control__WAB8E","richText":"Product_richText__sk8gv"};